export function travellerSignup(req) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      device_type: localStorage.getItem("deviceType"),
    },
    body: JSON.stringify(req),
  };
  return fetch("/shared/api/travellerSignup", requestOptions).then((response) =>
    response.json()
  );
}

export function travellerVerification(req) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      device_type: localStorage.getItem("deviceType"),
    },
    body: JSON.stringify(req),
  };
  return fetch("/shared/api/travellerVerification", requestOptions).then(
    (response) => response.json()
  );
}

export function resendMail(req) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      device_type: localStorage.getItem("deviceType"),
    },
    body: JSON.stringify(req),
  };
  return fetch("/shared/api/travellerRessendMail", requestOptions).then(
    (response) => response.json()
  );
}

export function resendMob(req) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      device_type: localStorage.getItem("deviceType"),
    },
    body: JSON.stringify(req),
  };
  return fetch("/shared/api/travellerResendMob", requestOptions).then(
    (response) => response.json()
  );
}
